import { Link } from "react-router-dom";
import {
  isPermissionPresent,
  pascalCase,
} from "../../../utilities/generalUtility";
import K from "../../../utilities/constants";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";

const displayBoolean = (params) => (params.data.isActive ? "Yes" : "No");

const tooltipDisplayBoolean = (params) => (
  <div className="client-list-tooltip">
    {params.data.isActive ? "Yes" : "No"}
  </div>
);

const displayType = (params) =>
  pascalCase(params.data?.type ?? K.NullPlaceholder);

const tooltipDisplayType = (params) => (
  <div className="client-list-tooltip">
    {pascalCase(params.data?.type ?? K.NullPlaceholder)}
  </div>
);

const displayOptional = (params) => params.data.jobTitle ?? K.NullPlaceholder;

const tooltipDisplayOptional = (params) => (
  <div className="client-list-tooltip">
    {params.data.jobTitle ?? K.NullPlaceholder}
  </div>
);

const phoneExtRenderer = (params) => params.data.phoneExt ?? K.NullPlaceholder;

const toolTipPhoneExtRenderer = (params) => (
  <div className="client-list-tooltip">
    {params.data.phoneExt ?? K.NullPlaceholder}
  </div>
);

const actionColumnRenderer = (roles) => (params) => (
  <>
    {isPermissionPresent(K.Permissions.EditUser, roles) && (
      <Link to={`/configurations/users/edit/${params.data.id}`}>
        <EditIconButton />
      </Link>
    )}
  </>
);

export const getColumns = (roles) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Full Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
    cellClass: "cursor-pointer",
  },
  {
    headerName: "Email",
    field: "email",
    sortable: true,
    tooltipField: "email",
    cellClass: "cursor-pointer",
  },
  {
    headerName: "Phone Number",
    field: "phone",
    sortable: true,
    tooltipField: "phone",
    cellClass: "cursor-pointer",
  },
  {
    headerName: "Phone Ext",
    field: "phoneExt",
    sortable: true,
    tooltipField: "phoneExt",
    cellClass: "cursor-pointer",
    tooltipComponent: toolTipPhoneExtRenderer,
    cellRenderer: phoneExtRenderer,
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    cellClass: "cursor-pointer",
    sortable: true,
    tooltipField: "jobTitle",
    tooltipComponent: (params) => tooltipDisplayOptional(params),
    cellRenderer: (params) => displayOptional(params),
  },
  {
    headerName: "Active",
    field: "isActive",
    cellClass: "cursor-pointer",
    sortable: true,
    tooltipField: "isActive",
    tooltipComponent: (params) => tooltipDisplayBoolean(params),
    cellRenderer: (params) => displayBoolean(params),
  },
  {
    headerName: "Type",
    field: "type",
    cellClass: "cursor-pointer",
    sortable: true,
    tooltipField: "type",
    tooltipComponent: (params) => tooltipDisplayType(params),
    cellRenderer: (params) => displayType(params),
  },

  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditUser, roles),
    cellRenderer: actionColumnRenderer(roles),
  },
];
